export default __webpack_public_path__ + "static/media/ai06.b2496ab0.png";